import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationTopographicSubsetLaboratoryCreateRequest, ConfigurationTopographicSubsetLaboratoryPatchInBatchRequest, ConfigurationTopographicSubsetLaboratoryResponse } from '@/modules/configurationModule/detail/local-samples/topographic-subset-laboratory/services/topographic-subset-laboratory.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class TopographicSubsetLaboratoriesConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationTopographicSubsetLaboratoryResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationTopographicSubsetLaboratoryResponse>>(`/configuration/laboratories/${laboratoryId}/topographicSubsetLaboratories`, filterModel, { params })
        return response.data
    }

    async getTopographicSubsetLaboratoryById(laboratoryId: number, topographicSubsetLaboratoryId: number): Promise<ConfigurationTopographicSubsetLaboratoryResponse> {
        const response = await axios.get<ConfigurationTopographicSubsetLaboratoryResponse>(`/configuration/laboratories/${laboratoryId}/topographicSubsetLaboratories/${topographicSubsetLaboratoryId}`)
        return response.data
    }

    async createTopographicSubsetLaboratory(laboratoryId: number, request: ConfigurationTopographicSubsetLaboratoryCreateRequest): Promise<ConfigurationTopographicSubsetLaboratoryResponse> {
        const response = await axios.post<ConfigurationTopographicSubsetLaboratoryResponse>(`/configuration/laboratories/${laboratoryId}/topographicSubsetLaboratories`, request)
        return response.data
    }

    async deleteTopographicSubsetLaboratory(laboratoryId: number, topographicSubsetLaboratoryIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/topographicSubsetLaboratories/batch`, { data: topographicSubsetLaboratoryIds })
        return response.data
    }

    async patchTopographicSubsetLaboratory(laboratoryId: number, requests: ConfigurationTopographicSubsetLaboratoryPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/topographicSubsetLaboratories/batch`, requests)
        return response.data
    }
}

export const topographicSubsetLaboratoriesConfigurationServices = new TopographicSubsetLaboratoriesConfigurationServices()
